import React from 'react';
import MUTypography from '../../../../../ui/MUTypography';
import CodeBlock from '@tenon-io/tenon-codeblock';
import './styles.css';
import sample from './Texts.js';
import {ApiUsageResponseTable, ApiUsageRequestTable, OTPMessageTable, MobileConfirmationTable, ApiUsageRequestMobileConfTable} from './index';

const Info10 = (props) =>
  <div>
    <MUTypography variant='h4' className={props.classes.h4}>
      OTP Handling
    </MUTypography>
    <br/>
    <MUTypography variant='h5' paragraph={true} className={props.classes.h5}>
      OTP Free Calls
    </MUTypography>
    <MUTypography variant='display1' className={props.classes.paragraph}>
      Each product has a specific endpoint and it should be added to base url while making a request.<br></br>
      You'll get response on Otp free apis.
      <br></br>
    </MUTypography>

    <MUTypography variant='h5' paragraph={true} className={props.classes.h5}>
      OTP Required Calls
    </MUTypography>
    <MUTypography variant='display1' className={props.classes.paragraph}>
      The customer can use sms or mobile confirmation login method while logging in via api banking.<br></br>
      Whichever login method was used when logged in, the same method must be used in the api call.
    </MUTypography>
    <br></br>
    <MUTypography variant='display1' className={props.classes.paragraph}>
      For example: If you log in with sms, sms will be used in the API call,<br></br>
      and if you log in with mobile confirmation, mobile confirmation will be used in the API call.
    </MUTypography>
    <MUTypography variant='h6' className={props.classes.h6}>
      Sms Flow
    </MUTypography>
    <MUTypography variant='display1' className={props.classes.paragraph}>
      Some of Albaraka APIs require otp(one time password) to complete call.<br></br>
      If your login type is "Sms" and you call an api, you will get "transaction_id" and "authenticationType" in the response.
    </MUTypography>
    <MUTypography variant='h6' paragraph={true} className={props.classes.h6}>
      Sample response:
    </MUTypography>
    <div style={{ width: 710 }}>
      <CodeBlock language="html" codeString={sample['transactionIdResp']} />
    </div>
    <MUTypography variant='display1' paragraph={true} className={props.classes.paragraph}>
      At the same time, user will be provided an otp message via sms.
    </MUTypography>
    <br></br>
    <OTPMessageTable/>
    <MUTypography variant='h6' className={props.classes.h6}>
      Mobile Confirmation Flow
    </MUTypography>
    <br/>
    <MUTypography variant='display1' className={props.classes.paragraph}>
      Mobile Confirmation is a method that enables us to log in to our internet branch and confirm transactions by confirming the notification (push notification)
      without entering any password on Albaraka Mobile instead of generating an SMS password or one-time password.<br></br>
    </MUTypography>
    <br/>
    <MUTypography variant='display1' className={props.classes.paragraph}>
      Some of Albaraka APIs require otp(one time password) to complete call.<br></br>
      If your login type is "Mobile Confirmation" and you call an api, you will get "transaction_id" , "authenticationType" , "activationId" and "requestId" in the response.
    </MUTypography>
    <MUTypography variant='h6' paragraph={true} className={props.classes.h6}>
      Sample response:
    </MUTypography>
    <div style={{ width: 710 }}>
      <CodeBlock language="html" codeString={sample['mobileConfirmationResp']} />
    </div>
    <MUTypography variant='display1' paragraph={true} className={props.classes.paragraph}>
      At the same time, user will be provided an push notification via recorded phone.
    </MUTypography>
    <br></br>
    <MobileConfirmationTable/>
    <br></br>
    <br></br>
    <MUTypography variant='display1' className={props.classes.paragraph}>
      To complete the API call process;<br></br>
      Depending on your login type, "sms" or "mobile confirmation" steps should be applied, and the required fields should be sent to the Execute Service below.<br></br>
      This endpoint is fixed for all otp required Albaraka APIs.
    </MUTypography>
    <br/>
    <MUTypography variant='display1' className={props.classes.paragraph}>
      <img src={require('./postIcon.png')} width="70" alt="POST"></img>
      <b>&nbsp;&nbsp;&nbsp;https://apitest.albarakaturk.com.tr/api/execute/</b>
    </MUTypography>
    <br></br>
    <MUTypography variant='h6' paragraph={true} className={props.classes.h6}>
      If your flow is "Sms", your body &amp; headers parameters should be like below:
    </MUTypography>
    <br></br>
    <ApiUsageRequestTable/>
    <MUTypography variant='h6' paragraph={true} className={props.classes.h6}>
      Sample request:
    </MUTypography>
    <br></br>
    <div style={{ width: 710 }}>
      <CodeBlock language="html" codeString={sample['transactionIdReq']} />
    </div>
    <br></br>
    <MUTypography variant='h6' paragraph={true} className={props.classes.h6}>
      If your flow is "Mobile Confirmation", your body &amp; headers parameters should be like below:
    </MUTypography>
    <br></br>
    <ApiUsageRequestMobileConfTable/>
    <MUTypography variant='h6' paragraph={true} className={props.classes.h6}>
      Sample request:
    </MUTypography>
    <br></br>
    <div style={{ width: 710 }}>
      <CodeBlock language="html" codeString={sample['mobileConfirmationReq']} />
    </div>
    <br/>
    <MUTypography variant='display1' paragraph={true} className={props.classes.paragraph}>
      On a successful execute call, execution of api will be completed and api specific response will be returned.<br></br>
      (also see responses : Response Object, How it works/Api )
    </MUTypography>
    <MUTypography variant='h5' className={props.classes.h5}>
      Response Object
    </MUTypography>
    <MUTypography variant='display1' paragraph={true} className={props.classes.paragraph}>
      Albaraka APIs has a standard JSON response object as shown below.
    </MUTypography>
    <br/>
    <div style={{ width: 710 }}>
      <CodeBlock
        language="html"
        codeString={'\{ "data"\: \{\},"header"\: \{"message"\: ,"status"\: "statusCode"\: ,"detailCode"\: ,"warnings": [],\} \}'} />
      <br/>
    </div>
    <MUTypography variant='display1' paragraph={true} className={props.classes.paragraph}>
      <ApiUsageResponseTable/>
      <br/>
    </MUTypography>
  </div>;

export default Info10;
